import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Mousewheel, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import styles from "./SingleSimilarEbooks.module.css";
import Loading from "../../../common/HousGlass Loader/Loading";
import { useNavigate } from "react-router-dom";
import { useSimilarEbooks } from "../../../hooks/useEbooksHooks";

function SingleSimilarBooks({ id }) {
  const { similarEbooks, isLoading, error } = useSimilarEbooks(id);
  const navigate = useNavigate();

  // If loading or no data, show a loading state or return null
  if (isLoading) {
    return (
      <div className={styles.container}>
        <Loading />
      </div>
    );
  }

  // If no similar books found or empty array
  if (!similarEbooks || similarEbooks.length === 0 || error) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className={styles.similarBooks}>
        <h2 className={styles.similarBooksTitle}>Similar E-Books</h2>
        <Swiper
           modules={[Mousewheel, FreeMode, Navigation]}
          freeMode={{
            enabled: true,
            momentum: true,
            momentumRatio: 1, // smoother momentum
            momentumVelocityRatio: 1, // normal velocity handling
            minimumVelocity: 0.02, // keep this small to allow tiny moves
          }}
          mousewheel={{
            forceToAxis: true,
            sensitivity: 1.5,
            releaseOnEdges: true,
          }}
          speed={400}
          resistance={true} // Allow a bit of resistance (helps feel natural)
          resistanceRatio={0.85}
          spaceBetween={10}
          breakpoints={{
            320: {
              slidesPerView: 3,
              spaceBetween: 10
            },
            480: {
              slidesPerView: 3,
              spaceBetween: 15
            },
            768: {
              slidesPerView: 4,
              spaceBetween: 20
            },
            1024: {
              slidesPerView: 6,
              spaceBetween: 20
            },
            1200: {
              slidesPerView: 7,
              spaceBetween: 20
            }
          }}
          className={styles.swiper}
        >
          {similarEbooks.map((book) => (
            <SwiperSlide key={book.id} className={styles.swiperSlide}>
              <div className={styles.bookCard}>
                <img
                  src={book.cover_image_url_for_computer || book.cover_image_url_for_mbl}
                  alt={book.title}
                  className={styles.bookCover}
                  onClick={() => navigate(`/book-detail/${book.slug}`)}
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}

export default SingleSimilarBooks;